import * as React from 'react';
import { Page, Pane } from '../../atoms/applications/page';
import { inject, observer } from 'mobx-react';
import { CompleteIcon } from '../../molecules/applications/CompleteIcon';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { ApplicationPageState } from '../../../containers/application/states/ApplicationPageState';
import './errorPane.module.scss';
import { translateErrorMessage } from '../../../../commonv3/api/protocol';

type Props = {
  applicationState: ApplicationPageState;
};

export const ErrorPane = inject('applicationState')(
  observer(
    class ErrorPane extends React.Component<Props> {
      render() {
        const { restart, error } = this.props.applicationState;
        return (
          <Page>
            <Pane>
              <CompleteIcon />
              <div styleName="header">お申し込みに失敗しました。</div>
              <div styleName="message">
                以下の理由により、お申し込みを受け付けられませんでした。
                <br />
                {translateErrorMessage(error)}
                <br />
                原因を確認の上、やり直してください。
              </div>
              <div styleName="button-wrapper">
                <Button type="normal" size="l" onClick={restart}>
                  初めからやり直す
                </Button>
              </div>
            </Pane>
          </Page>
        );
      }
    }
  )
);
